const state = {
  columns: [],
  columnsValues: {},
  columnsIds: {},
};

const getters = {
  getColumn: (state) => (id) => {
    return state.columns.find(item => {
      return item.id == id
    })
  },
  getColumns: (state) => {
    return state.columns
  },
  getColumnValue: (state) => (id) => {
    return state.columnsValues[id]
  },
  getColumnValues: (state) => {
    return state.columnsValues
  },
  getColumnsByParent: (state) => (parentId) => {
    return state.columns.filter(item => {
      return item.parentId == parentId
    })
  },
};

const mutations = {
  setColumn: (state, {id, label, parentId, tableId, defaultValue}) => {
    let index = state.columns.findIndex(item => item.id == id)
    let item = {id, label, parentId, tableId, defaultValue}
    if (index == -1) {
      state.columns.push(item)
      if (!(id in state.columnsValues)) {
        state.columnsValues = {...state.columnsValues, [id]: !!defaultValue}
      }
    } else {
      let equal = Object.keys(item).every(key => {
        return state.columns[index][key] === item[key]
      })
      if (!equal) {
        state.columns = {...state.columns, [index]: item}
        state.columnsValues = {...state.columnsValues, [id]: !!defaultValue}
      }
    }
  },
  setColumnsIds: (state, {tableId, columnsIds}) => {
    // Не работатает, когда в самом компоненте делаю map по columns
    state.columnsIds[tableId] = state.columns.map(col => col.id)
  },
  unsetColumns: (state, {tableId, columnsIds}) => {
    // TODO: Посмотреть. Не используется.
    // let tableColLength = state.columns.filter(a => a.tableId === tableId).length
    // tableColLength += 1
    // let cond3 = state.columnsIds[tableId] && columnsIds.length === tableColLength
    // let cond4 = cond3 && columnsIds.some(item => state.columnsIds[tableId].includes(item), columnsIds, state.columnsIds)
    let cond1 = state.columnsIds[tableId] && columnsIds.length === state.columnsIds[tableId].length
    let cond2 = cond1 && columnsIds.every(item => state.columnsIds[tableId].includes(item))

    let cond = !cond1 || !cond2
    if (cond) {

      // state.columnsIds[tableId] = columnsIds
      // let columns = state.columns.filter(item => item.tableId != tableId)
      // state.columns = columns
      // let columnsValues = {}
      // columns.forEach(item => {
      //   columnsValues[item.id] = state.columnsValues[item.id]
      // })
      // state.columnsValues = columnsValues
    }
  },
  setColumnValue: (state, {id, value}) => {
    if (state.columnsValues[id] != value) {
      state.columnsValues = {...state.columnsValues, [id]: value}
    }
  },
  setColumnValues: (state, payload) => {
    state.columnsValues = payload
  },
  removeColumn: (state, {id}) => {
    const columns = state.columns.filter(item => item.id !== id)
    if (columns.length !== state.columns.length) {
      state.columns = columns
    }
    if (Object.prototype.hasOwnProperty.call(state.columnsValues, id)) {
      const {[id]: removed, ...rest} = state.columnsValues
      state.columnsValues = rest
    }
    if (state.columnsIds && Object.keys(state.columnsIds).length) {
      let updated = false
      const newColumnsIds = {...state.columnsIds}
      Object.keys(newColumnsIds).forEach(tableId => {
        const ids = newColumnsIds[tableId]
        if (!Array.isArray(ids)) {
          return
        }
        const filtered = ids.filter(colId => colId !== id)
        if (filtered.length !== ids.length) {
          newColumnsIds[tableId] = filtered
          updated = true
        }
      })
      if (updated) {
        state.columnsIds = newColumnsIds
      }
    }
  },
  clearColumns: (state) => {
    state.columnsValues = {}
    state.columnsIds = {}
    state.columns = []
  },
  unsetClearColumns: (state, {tableId, columnsIds}) => {
    state.columnsIds = {}
  },
};

const actions = {
  actionSetColumn: ({commit}, payload) => {
    commit("setColumn", payload);
  },
  actionUnsetColumns: ({commit}, payload) => {
    commit("unsetColumns", payload);
  },
  actionSetColumnsIds: ({commit}, payload) => {
    commit("setColumnsIds", payload);
  },
  actionSetColumnValue: ({commit}, payload) => {
    commit("setColumnValue", payload);
  },
  actionSetColumnValues: ({commit}, payload) => {
    commit("setColumnValues", payload);
  },
  actionRemoveColumn: ({commit}, payload) => {
    commit("removeColumn", payload);
  },
  actionClearColumns: ({commit}) => {
    commit("clearColumns");
  },
  actionUnsetClearColumns: ({commit}, payload) => {
    commit("unsetClearColumns", payload);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
